import {
  INotificationClear,
  INotificationConfirm,
  INotificationCongrat,
  NEW_NOTIFICATION,
  OneNotification,
} from "./types";

export function notificationAppear(
  notif: OneNotification
): INotificationCongrat {
  return {
    type: NEW_NOTIFICATION.NEW_NOTIFICATION_APPEARS,
    payload: notif,
  };
}

export function notificationView(notif: OneNotification): INotificationCongrat {
  return {
    type: NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW,
    payload: notif,
  };
}

export function notificationViewFeedback(
  notif: OneNotification
): INotificationCongrat {
  return {
    type: NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW_FEEDBACK,
    payload: notif,
  };
}

export function notificationConfirm(
  notif: OneNotification
): INotificationConfirm {
  return {
    type: NEW_NOTIFICATION.NEW_NOTIFICATION_CONFIRM,
    payload: notif,
  };
}

export function notificationCongrat(
  notif: OneNotification
): INotificationCongrat {
  return {
    type: NEW_NOTIFICATION.NEW_NOTIFICATION_CONGRAT,
    payload: notif,
  };
}
export function notificationClear(notif: OneNotification): INotificationClear {
  return {
    type: NEW_NOTIFICATION.NEW_NOTIFICATION_CLEAR,
    payload: notif,
  };
}
